module.exports = {
  WEATHER_DATA_REQUEST: 'WEATHER_DATA_REQUEST',
  WEATHER_DATA_SUCCESS: 'WEATHER_DATA_SUCCESS',
  WEATHER_DATA_FAILURE: 'WEATHER_DATA_FAILURE',
};
